import type { RtcLogEntry } from '../rtc/rtc-manager'

const RTC_CONSOLE_LOG_PREFIX = '[Xmax]'

export function writeRtcLogToConsole(entry: RtcLogEntry): void {
  if (!entry.message.startsWith(RTC_CONSOLE_LOG_PREFIX)) {
    return
  }

  const args = entry.data === undefined
    ? [entry.message]
    : [entry.message, entry.data]

  if (entry.level === 'error') {
    console.error(...args)
  } else if (entry.level === 'warn') {
    console.warn(...args)
  } else {
    console.info(...args)
  }
}
